export default __webpack_public_path__ + "static/media/IndustrialApplicationsCardImg21.62ef3ff0.png";